import React from "react";

import { GradientDefs } from "../../GradientDefs";

/**
 * @component StatusIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 * @prop {string} [gradient] - Optional CSS linear-gradient string to apply a custom fill.
 * Format: "linear-gradient(<angle>deg, <color1>, <color2>, ...)"
 *
 * @example
 * return (
 * <StatusIcon gradient="linear-gradient(135deg, #4da2ed, #f72222)" />
 * )
 *
 * @example
 * return (
 *   <StatusIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const StatusIcon = React.forwardRef(
  (
    {
      gradient,
      ...props
    }: React.SVGProps<SVGSVGElement> & {
      gradient?: string;
    },
    ref?: React.Ref<SVGSVGElement>
  ) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      data-testid="StatusIcon"
      fill={
        gradient
          ? "url(#icon-gradient)"
          : props?.fill
          ? props.fill
          : "var(--color-theme-600)"
      }
      focusable={false}
      ref={ref}
      {...props}
    >
      <GradientDefs gradient={gradient} />
      <path
        fillRule="evenodd"
        d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2m0 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16"
        clipRule="evenodd"
      />
      <path
        fillRule="evenodd"
        d="M10.579 6.003a1 1 0 0 1 .875.696l2.3 7.285 1.372-2.47A1 1 0 0 1 16 11h2a1 1 0 1 1 0 2h-1.412l-2.214 3.986a1 1 0 0 1-1.828-.185L10.29 9.656l-1.396 2.791A1 1 0 0 1 8 13H6a1 1 0 1 1 0-2h1.382l2.224-4.447a1 1 0 0 1 .973-.55"
        clipRule="evenodd"
      />
    </svg>
  )
);
StatusIcon.displayName = "StatusIcon";
export default StatusIcon;
